










import { defineComponent } from '@nuxtjs/composition-api';
export default defineComponent({
  name: 'BaseOverlay',
  props: {
    transition: {
      type: String,
      default: 'sf-fade',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data(...args): any {
    return args;
  },
});
